import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LookupModalService } from './services/lookup-modal.service';
import { OrderByPipe } from 'src/app/shared/pipe/order-by.pipe';

@Component({
  selector: 'app-lookup-modal',
  templateUrl: './lookup-modal.component.html',
  styleUrls: ['./lookup-modal.component.css']
})

export class LookupModalComponent implements OnInit {
  orderByPipe: OrderByPipe;
  rowOrderValue: string;
  filterValue: string | null;
  selectedLookupCategory: string;
  reverseSortOrder: boolean | null;
  retrievingLookups: boolean;
  columnHeaders: string[];
  lookupRows: object[];
  filteredRows: object[];
  pageRows: object[];
  selectedRow: object | null;
  paginationData: {
    maxItemsPerPage: number;
    maxPageCountDisplay: number;
    totalItemCount: number;
    currentPage: number;
  }
  @Input() lookupParams: {
    co: number;
    form: string;
    seq: number;
    lookup: string;
    formData: string;
    showAllColumns: boolean;
    searchString: string;
  };
  @Input() availableLookups: {
    LoadSeq: number,
    Lookup: string,
    Title: string
  }[];
  @Input() modalTitle: string;

  constructor(
    private lookupService: LookupModalService,
    private ngbActiveModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.orderByPipe = new OrderByPipe();
    this.rowOrderValue = "";
    this.filterValue = null;
    this.reverseSortOrder = null;
    this.retrievingLookups = false;
    this.columnHeaders = [];
    this.lookupRows = [];
    this.filteredRows = [];
    this.pageRows = [];
    this.selectedRow = null;
    this.paginationData = {
      maxItemsPerPage: 10,
      maxPageCountDisplay: 10,
      totalItemCount: 0,
      currentPage: 1
    }
    this.setLookupCategory();
    this.getLookupList();
  }

  setLookupCategory() {
    if (this.availableLookups.length > 1) {
      this.availableLookups.sort((a, b) => a.LoadSeq - b.LoadSeq);
      this.selectedLookupCategory = this.availableLookups[0].Lookup;
    } else {
      this.selectedLookupCategory = this.lookupParams.lookup;
    }
  }

  getLookupList() {
    this.retrievingLookups = true;
    this.lookupService.getLookup(this.lookupParams)
      .then((response: any) => {
        this.columnHeaders = Object.keys(response[0]);
        this.lookupRows = response;
        this.filteredRows = this.lookupRows;
        this.paginationData.totalItemCount = this.filteredRows.length;
        this.updatePageRows(this.paginationData.currentPage);
        this.retrievingLookups = false;
      }).catch(error => this.retrievingLookups = false);
  }

  closeLookupModal() {
    this.ngbActiveModal.close(this.selectedRow);
  }

  orderTableByValue(orderValue: string) {
    if (this.rowOrderValue === orderValue) {
      this.reverseSortOrder = !this.reverseSortOrder;
    } else {
      this.rowOrderValue = orderValue;
    }
    this.filteredRows = this.orderByPipe.transform(
      this.filteredRows, [orderValue], this.reverseSortOrder ? "desc" : "asc"
    );
    this.updatePageRows(this.paginationData.currentPage);
  }

  filterLookupTable() {
    this.filteredRows = this.lookupRows.filter((row) => this.rowContainsSubstring(row));
    this.paginationData.totalItemCount = this.filteredRows.length;
    this.updatePageRows(this.paginationData.currentPage);
  }

  rowContainsSubstring(row: object) {
    let rowContainsSubstring = false;
    this.columnHeaders.forEach((key) => {
      if (row[key] != null && row[key].toString().toLowerCase().includes(this.filterValue)) {
        rowContainsSubstring = true;
        return;
      }
    });
    return rowContainsSubstring;
  }

  selectRow(row: object) {
    this.selectedRow = row;
    this.closeLookupModal();
  }

  triggerLookup() {
    if (this.selectedLookupCategory != null) {
      this.lookupParams.lookup = this.selectedLookupCategory;
      this.filteredRows = [];
      this.pageRows = [];
      this.getLookupList();
    }
  }

  updatePageRows(selectedPage: number) {
    const begin = ((selectedPage - 1) * this.paginationData.maxItemsPerPage);
    const end = begin + this.paginationData.maxItemsPerPage;
    this.pageRows = this.filteredRows.slice(begin, end);
  }
}
